import type { UseFormReturn } from 'react-hook-form';
import {
  Disclosure,
  DisclosureButton,
  Labeled,
  TextInputField,
} from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { ICategoryFormValues } from './CategoryForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type ICategoryFormAdvancedOptionsSectionProps = IContainerProps & {
  form: UseFormReturn<ICategoryFormValues>;
  mode: IFormMode;
};

export const CategoryFormAdvancedOptionsSection: React.FC<
  ICategoryFormAdvancedOptionsSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <Disclosure
      sx={sx}
      trigger={
        <DisclosureButton>{t('common.advanced-options')}</DisclosureButton>
      }
    >
      <FormSection sub>
        <Labeled
          label={t('CategoryFormAdvancedOptionsSection.field.authorName.label')}
        >
          <FormField
            name="authorName"
            control={form.control}
            as={TextInputField}
            forwardError
          />
        </Labeled>

        <Labeled
          label={t('CategoryFormAdvancedOptionsSection.field.rssFeedUrl.label')}
        >
          <FormField
            name="rssFeedUrl"
            control={form.control}
            as={TextInputField}
            forwardError
          />
        </Labeled>
      </FormSection>
    </Disclosure>
  );
};
